/* VitaWalk attribution passthrough — vw-attr.js
   Loaded SYNCHRONOUSLY as the first script in <head>, BEFORE {{ content_for_header }},
   on every storefront page (theme.liquid, page.of01.liquid, page.ca01.liquid).

   One job: no ad parameter is ever lost between the ad click and the order.

   1. capture   every utm_* and every known click id off the URL
   2. persist   cookie on .shopvitawalk.com (30 d) + localStorage + sessionStorage
   3. reflect   write them back into the address bar before Shopify's own analytics
                reads location, so landing_site carries them too
   4. decorate  every internal link, at render time, on DOM mutation, AND again at
                click time. Click time is the one that counts: vw-offer.js and
                vw-cart.js both overwrite href with a freshly built string.
   5. stamp     the cart, and put attributes[...] on the checkout permalink, because
                a /cart/<id>:<qty> permalink WIPES cart attributes set earlier. That
                is the whole reason attribution never reached an order before.
   6. expose    window.vwAttr.decorate(url) / .decorateCheckout(url) / .get()

   Idempotent everywhere: decorating an already decorated URL is a no-op. */
(function () {
  'use strict';

  var KEY = 'vw_attr';
  var CART_SIG = 'vw_attr_cart';
  var DAYS = 30;
  var MAX_KEYS = 30;
  var MAX_LEN = 512;

  /* ---------- 1. what counts as an ad parameter ---------- */
  var EXACT = {};
  ('fbclid fbc fbp gclid gbraid wbraid dclid ttclid msclkid twclid li_fat_id epik ' +
   'sccid irclickid rdt_cid ko_click_id yclid obclid tblci awc clickid click_id cid ' +
   'affid aff ref adset adset_id adset_name campaign_id campaign_name ad_id ad_name ' +
   'plc placement site_source_name pub').split(' ').forEach(function (k) { EXACT[k] = 1; });

  var PATTERNS = [/^utm_/, /^rtk/, /^sub[0-9]{1,2}$/, /^hyros/, /^ef_/, /^everflow/];

  function isAdParam(k) {
    var lk = k.toLowerCase();
    if (EXACT[lk]) return 1;
    for (var i = 0; i < PATTERNS.length; i++) if (PATTERNS[i].test(lk)) return 1;
    return 0;
  }

  function has(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }
  function enc(s) { return encodeURIComponent(s); }

  function parseQuery(search) {
    var out = {};
    if (!search || search.length < 2) return out;
    search.slice(1).split('&').forEach(function (pair) {
      if (!pair) return;
      var i = pair.indexOf('=');
      var k = i < 0 ? pair : pair.slice(0, i);
      var v = i < 0 ? '' : pair.slice(i + 1);
      try { k = decodeURIComponent(k.replace(/\+/g, ' ')); } catch (e) {}
      try { v = decodeURIComponent(v.replace(/\+/g, ' ')); } catch (e) {}
      if (k) out[k] = v;
    });
    return out;
  }

  /* ---------- 2. storage ---------- */
  function cookieWrite(val) {
    var base = KEY + '=' + enc(val) +
               ';expires=' + new Date(Date.now() + DAYS * 864e5).toUTCString() +
               ';path=/;SameSite=Lax';
    if (/(^|\.)shopvitawalk\.com$/i.test(location.hostname)) {
      document.cookie = base + ';domain=.shopvitawalk.com';
    } else {
      document.cookie = base;
    }
  }
  function cookieRead() {
    var m = document.cookie.match(/(?:^|;\s*)vw_attr=([^;]*)/);
    if (!m) return '';
    try { return decodeURIComponent(m[1]); } catch (e) { return ''; }
  }
  function lsGet(store) { try { return window[store].getItem(KEY) || ''; } catch (e) { return ''; } }
  function lsSet(store, v) { try { window[store].setItem(KEY, v); } catch (e) {} }

  /* ---------- 3. resolve the live attribution set ---------- */
  var incoming = {};
  (function () {
    var q = parseQuery(location.search);
    for (var k in q) {
      if (!has(q, k) || !q[k]) continue;
      if (!isAdParam(k)) continue;
      incoming[k] = String(q[k]).slice(0, MAX_LEN);
    }
  })();

  var stored = {};
  (function () {
    var raw = cookieRead() || lsGet('localStorage') || lsGet('sessionStorage');
    if (!raw) return;
    try {
      var o = JSON.parse(raw);
      if (o && typeof o === 'object') stored = o;
    } catch (e) {}
  })();

  /* A fresh ad click replaces the stored set outright. Merging would blend two
     campaigns into one order and make every report a lie. */
  var FRESH = ('utm_source utm_campaign utm_medium utm_content utm_term fbclid gclid ' +
               'gbraid wbraid ttclid msclkid twclid li_fat_id epik irclickid rtkcid rdt_cid').split(' ');
  var isFresh = false;
  for (var f = 0; f < FRESH.length; f++) { if (incoming[FRESH[f]]) { isFresh = true; break; } }

  var data = {};
  if (isFresh) {
    for (var a in incoming) if (has(incoming, a)) data[a] = incoming[a];
  } else {
    for (var b in stored) if (has(stored, b) && stored[b]) data[b] = String(stored[b]).slice(0, MAX_LEN);
    for (var c in incoming) if (has(incoming, c)) data[c] = incoming[c];
  }

  (function cap() {
    var keys = Object.keys(data);
    if (keys.length <= MAX_KEYS) return;
    for (var i = MAX_KEYS; i < keys.length; i++) delete data[keys[i]];
  })();

  var KEYS = Object.keys(data);
  var ACTIVE = KEYS.length > 0;

  if (ACTIVE) {
    var ser = JSON.stringify(data);
    cookieWrite(ser);
    lsSet('localStorage', ser);
    lsSet('sessionStorage', ser);
  }

  /* ---------- 4. reflect into the address bar, before Shopify reads it ---------- */
  (function reflect() {
    if (!ACTIVE) return;
    if (!window.history || !history.replaceState) return;
    if (/^\/(checkouts?|cart\/)/.test(location.pathname)) return;
    var here = parseQuery(location.search);
    var add = [];
    for (var i = 0; i < KEYS.length; i++) {
      var k = KEYS[i];
      if (has(here, k)) continue;
      add.push(enc(k) + '=' + enc(data[k]));
    }
    if (!add.length) return;
    var q = location.search ? location.search.slice(1) : '';
    q += (q ? '&' : '') + add.join('&');
    try {
      history.replaceState(history.state, '', location.pathname + '?' + q + location.hash);
    } catch (e) {}
  })();

  /* ---------- 5. link decoration ---------- */
  var SAME_SITE = /(^|\.)shopvitawalk\.com$|(^|\.)myshopify\.com$|(^|\.)shop\.app$/i;
  var PERMALINK = /^\/cart\/[0-9]/;

  function decorate(href, forceAttrs) {
    if (!ACTIVE || href == null) return href;
    var s = String(href), t = s.trim();
    if (!t || t.charAt(0) === '#') return href;
    if (/^(mailto:|tel:|sms:|javascript:|data:|blob:)/i.test(t)) return href;

    var a = document.createElement('a');
    try { a.href = t; } catch (e) { return href; }
    if (a.protocol !== 'http:' && a.protocol !== 'https:') return href;
    if (a.hostname !== location.hostname && !SAME_SITE.test(a.hostname)) return href;

    var path = a.pathname || '/';
    if (path.charAt(0) !== '/') path = '/' + path;          /* IE/legacy pathname quirk */
    var here = parseQuery(a.search);
    var add = [], i, k;

    for (i = 0; i < KEYS.length; i++) {
      k = KEYS[i];
      if (has(here, k)) continue;
      add.push(enc(k) + '=' + enc(data[k]));
    }
    /* attributes[...] only on a cart permalink: that is the only place Shopify
       accepts them, and the permalink is exactly what clears the cart otherwise. */
    if (forceAttrs || PERMALINK.test(path)) {
      for (i = 0; i < KEYS.length; i++) {
        k = 'attributes[' + KEYS[i] + ']';
        if (has(here, k)) continue;
        add.push(enc(k) + '=' + enc(data[KEYS[i]]));
      }
    }
    if (!add.length) return href;

    var q = a.search ? a.search.slice(1) : '';
    q += (q ? '&' : '') + add.join('&');
    var tail = path + '?' + q + (a.hash || '');
    if (a.host === location.host && !/^[a-z][a-z0-9+.-]*:/i.test(t)) return tail;
    return a.protocol + '//' + a.host + tail;
  }

  function decorateEl(el) {
    var h = el.getAttribute('href');
    if (h == null) return;
    var d = decorate(h);
    if (d !== h) el.setAttribute('href', d);
  }

  function sweep(root) {
    if (!ACTIVE) return;
    var scope = root || document;
    if (!scope.querySelectorAll) return;
    var list = scope.querySelectorAll('a[href]');
    for (var i = 0; i < list.length; i++) decorateEl(list[i]);
  }

  /* click time wins: the funnel engines rewrite href from a template string */
  function atClick(e) {
    if (!ACTIVE) return;
    var t = e.target;
    while (t && t.nodeType === 1) {
      if (t.tagName === 'A' && t.hasAttribute('href')) { decorateEl(t); return; }
      t = t.parentNode;
    }
  }
  ['pointerdown', 'mousedown', 'touchstart', 'click', 'auxclick'].forEach(function (ev) {
    document.addEventListener(ev, atClick, { capture: true, passive: true });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.keyCode === 13) atClick(e);
  }, true);

  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'attributes') {
          if (m.target && m.target.tagName === 'A') decorateEl(m.target);
          continue;
        }
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (!n || n.nodeType !== 1) continue;
          if (n.tagName === 'A') decorateEl(n);
          sweep(n);
        }
      }
    }).observe(document.documentElement, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['href']
    });
  }

  /* ---------- 6. stamp the cart (covers the PDP / drawer path) ---------- */
  function stampCart() {
    if (!ACTIVE || !window.fetch) return;
    if (!/(^|\.)shopvitawalk\.com$|(^|\.)myshopify\.com$/i.test(location.hostname)) return;
    var sig = JSON.stringify(data);
    try { if (sessionStorage.getItem(CART_SIG) === sig) return; } catch (e) {}
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: data })
    }).then(function (r) {
      if (r && r.ok) { try { sessionStorage.setItem(CART_SIG, sig); } catch (e) {} }
    })['catch'](function () {});
  }

  function boot() { sweep(document); stampCart(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', function () { sweep(document); });

  /* ---------- 7. public API ---------- */
  window.vwAttr = {
    active: ACTIVE,
    get: function () { var o = {}; for (var k in data) if (has(data, k)) o[k] = data[k]; return o; },
    query: function () {
      var p = [];
      for (var i = 0; i < KEYS.length; i++) p.push(enc(KEYS[i]) + '=' + enc(data[KEYS[i]]));
      return p.join('&');
    },
    decorate: function (u) { return decorate(u, false); },
    decorateCheckout: function (u) { return decorate(u, true); },
    stamp: stampCart,
    sweep: sweep
  };
})();
